// List of the documentation (ie "help") pages, so that we don't have to repeat it in various places

import { RouteConfig } from 'vue-router'

export const docPages: Array< { name: string; route: RouteConfig } > = [
    { name: "Quick Start",    route: { path: "/quickstart",     component: () => import("./DocQuickStart.vue") } },
    { name: "Glossary",       route: { path: "/glossary",       component: () => import("./DocGlossary.vue") } },
    { name: "How To ...",     route: { path: "/howto",          component: () => import("./DocHowTo.vue") } },
    { name: "FAQ",            route: { path: "/faq",            component: () => import("./DocFAQ.vue") } },
    { name: "Migrate from RideWithGPS", route: { path: "/migrate-from-ridewithgps", component: () => import("./DocMigrateRideWithGps.vue") } },
    { name: "Privacy Policy", route: { path: "/privacy",        component: () => import("./DocPrivacy.vue"), meta: { doLogin:true } } }
];
